import { Box, Flex, Text } from "@chakra-ui/react";
import { useContaCorrente } from "../../hooks/contaCorrente/useContaCorrente";
import { Loading } from "../../components/Loading";
import { formatBRL } from "../../utils/currency";

export function ContaCorrente(){
  const {data, isLoading} = useContaCorrente();

  if(isLoading) return <Loading />

  if(typeof data === "undefined" || typeof data.agencia === "undefined") return <Text>Não é possível carregar a conta nesse momento</Text>
  if(typeof data === "undefined" || typeof data.conta === "undefined") return <Text>Não é possível carregar a conta nesse momento</Text>

  const {agencia, conta} = data

  return (
    <Box
          gap={8}
          fontSize={"sm"}
          p={"5"}
          border={"1px solid #ccc"}
          display={"flex"}
          flexDir={"column"}
        >
            <Box
              mt={"-8"}
              fontWeight={"bold"}
              bg={"white"}
              as={"span"}
              w={"150px"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              Conta Corrente
            </Box>
            <Flex justifyContent={'space-between'}>
            <Flex flexDirection={'column'}>
                <Text fontSize={'sm'}>Agência</Text>
                <Text fontSize={'2xl'} fontWeight={'bold'}>{agencia.nome}</Text>
              </Flex>
              <Flex flexDirection={'column'} textAlign={'end'}>
                <Text fontSize={'sm'}>Saldo {conta.saldo <= 0 ? 'a receber' : 'a pagar'}</Text>
                <Text fontSize={'3xl'} color={conta.saldo <= 0 ? 'green.500' : 'red.500'} fontWeight={'bold'}>{formatBRL(Math.abs(conta.saldo))}</Text>
              </Flex>
            </Flex>
      </Box>
  )
}